import React from 'react';
import { View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

import { Card, Text } from '@/ui';
import { Icon } from '@/ui/icon';
import { Bolt } from '@/ui/icons/bolt';

export default function BatteryCheck() {
  const { styles, theme } = useStyles(stylesheet);

  return (
    <View style={styles.container}>
      <View style={{ gap: 8 }}>
        <Text type="title1">Battery Check</Text>

        <Text type="bodyRegular" style={{ color: theme.colors.text.secondary }}>
          Maintaining proper charge is important. Never let the battery level
          drop to 0% as it can leave you stranded and damage the battery.
        </Text>
      </View>

      <View>
        <Card>
          <View style={{ padding: 16, gap: 8 }}>
            <View
              style={{ flexDirection: 'row', gap: 8, alignItems: 'center' }}
            >
              <Icon
                type="dressed"
                icon={<Bolt />}
                fillColor={theme.colors.icon.color}
                width={25}
                height={25}
              />

              <Text type="bodyRegular">Battery level</Text>
            </View>

            <View>
              <Text type="title1">15%</Text>
            </View>

            <View>
              <View
                style={{
                  height: 16,
                  borderRadius: 8,
                  width: '100%',
                  backgroundColor:
                    theme.colors.progressBar.inactive.backgroundColor,
                }}
              >
                <View
                  style={{
                    height: 16,
                    borderRadius: 8,
                    width: '15%',
                    backgroundColor: theme.colors.error,
                  }}
                />
              </View>
            </View>
          </View>
        </Card>
      </View>
    </View>
  );
}

const stylesheet = createStyleSheet((theme) => ({
  container: {
    minWidth: '100%',
    gap: 24,
    backgroundColor: theme.colors.background_1,
    justifyContent: 'space-between',
  },
}));
